<template>
  <div class="Material_management">
    <div class="tp">
      <h2 style="display: inline-block;">音频（共{{Counts}}条）</h2>
      <el-input placeholder="请输入内容" v-model="name" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="loading()"></el-button>
      </el-input>
      <el-button style="display:inline-block;margin-right:40px;float: right;" size="small" type="primary" @click="dialogrename3 = true">点击上传</el-button>
      <span style="float: right;line-height:34px;margin-right:20px;"></span>
    </div>
    <div>
      <h4 style="width: 80px;display: inline-block;text-align:center;float: left;margin-top:10px">全部</h4>
      <ul class="tp_ul1">
        <li v-for="(item,i) in allMaterialGroups" :key="i" @click="zzfun(i,item)" :class="zzindex == i?'Select':'bbbb'">{{item.groupName}}</li>
      </ul>
      <div style="float: right;">
        <el-popover style="margin-right:15px" size="small" plain placement="right" width="200" trigger="click">
          <div style="text-align:center;font-weight: 700;">
            请输入分组名称
            <el-input style="margin-top:15px;margin-bottom:15px;" v-model="groupName" placeholder="请输入内容"></el-input>
            <el-button size="small" plain type="primary" style="margin-bottom:10px;" @click="addGroup()">新增</el-button>
          </div>
          <el-button slot="reference">新增</el-button>
        </el-popover>
        <el-popover style="margin-right:25px" placement="right" width="400" trigger="click">
          <div style="width: 400px;height: 500px;">
            <h2 style="font-size: 18px;">管理分组</h2>
            <ul class="allMaterialGroups">
              <li v-for="(item,i) in allMaterialGroups" :key="i">
                <span style="float: left;">{{item.groupName}}</span>
                <el-popover placement="top-start" title="提示" width="200" trigger="hover" content="分组删除后分组内数据也会被删除，请谨慎操作!">
                  <el-button style="float:right;cursor:pointer;margin-right:10px;font-size: 18px;line-height:38px;" type="text" class="el-icon-delete" slot="reference" @click="dels(item.keyNo)"></el-button>
                </el-popover>
                <span style="float:right;cursor:pointer;margin-right:10px;font-size: 18px;line-height:38px;" class="el-icon-edit" @click="edit(item.keyNo)"></span>
                <!-- <span style="float: right;cursor: pointer; font-size: 18px;line-height:38px" class="el-icon-delete" @click="dels(item.keyNo)"></span> -->
              </li>
            </ul>
          </div>
          <el-button slot="reference">管理</el-button>
        </el-popover>
      </div>
    </div>
    <div  v-if="selesdata.length>0" style="height: 40px;background:rgba(246, 247, 248, 1);text-indent:20px;line-height:40px;color: rgba(40, 40, 40, 1);">
      <span>已选择{{selesdata.length}}项内容</span> <span @click="deselect()" style="color: rgba(62, 123, 176, 1);margin-left:30px;cursor: pointer;">取消选择</span>
      <span style="float: right;margin-right:20px;font-size: 20px;cursor: pointer;">
        <i class="el-icon-s-promotion" title="发布"  @click="publish2()"></i>
        <i class="el-icon-delete" title="删除" @click="pldel()"></i>
        <i class="el-icon-rank" title="移动分组" @click='Movefun("多")'></i>
      </span>
    </div>
    <ul class="nav_ul">
      <li v-for="(item,index) in datalist" :key="index"  @click.stop="toggleSelect(item.materialKey,index)">
        <img :src="item.materialCover" alt="">
        <img v-if="isSelected(index)" style="width: 20px;height: 20px;position: absolute;top:10px;left:10px;" src="../../assets/ccscsqw.png" alt="">
        <img class="cz" style="width: 40px;height: 40px;position: absolute;top:0px;right:0px;" src="../../assets/jyj.png" alt="">
        <div class="sibling">
          <div style="width: 0;height: 0;border-top: 10px solid transparent; border-right: 10px solid transparent;border-left: 10px solid transparent;border-bottom: 22px solid #fff;position: absolute;top:-22px;right: 0px;">
          </div>
          <ul>
            <li @click.stop="rename(item.materialKey)">重命名</li>
            <li @click.stop="Movefun(item.materialKey)">移动分组</li>
            <li @click.stop="publish(item.materialKey)">发布</li>
            <li @click.stop="delfun(item.materialKey)">删除</li>
          </ul>
        </div>
        <!-- <p>{{item.materialName}}</p> -->
        <p>{{item.materialName}}  <i style="color: rgba(0, 136, 255, 1);">（{{item.materialLibraryStatus == 1?'已':'未'}}）</i> </p>
      </li>
    </ul>
    <div class="block" style="margin-right:15px;">
      <el-pagination @current-change="handleSizeChange" :current-page="pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts2"></el-pagination>
    </div>
    <!-- 修改图片名称 -->
    <el-dialog title="修改名称" :visible.sync="dialogrename" width="320px">
      <el-input v-model="input3" placeholder="请输入图片名称"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogrename = false">取 消</el-button>
        <el-button type="primary" @click="renamefun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改分组名称 -->
    <el-dialog title="修改名称" :visible.sync="dialogrename2" width="320px">
      <el-input v-model="fzdataL" placeholder="请输入分组名称"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogrename2 = false">取 消</el-button>
        <el-button type="primary" @click="editfun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上传 -->
    <el-dialog title="上传音频" :visible.sync="dialogrename3" width="520px">
      <div v-loading="updataloading">
        <div style="height: 120px;">
          <h2 style="display: inline-block;font-size: 18px;float: left;">音频</h2>
          <span style="margin-left:20px;display: inline-block;width: 420px;">格式支持mp3、mov，文件大小不超过200M，音频时长不超过2小时。上传后音频将进行转码和审核</span>
          <el-upload style="margin-left:56px;margin-top:15px" accept=".mp3,.mov" action="" :show-file-list='show_file' :auto-upload="false" :on-change="handleChange2">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
        <div style="height: 230px;">
          <h2 style="display: inline-block;font-size: 18px;float: left;">封面</h2>
          <el-upload style="margin-left:56px;width: 200px;height: 150px;border:1px solid #cbcbcb;"  :on-change="handleChange3" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg,.jpeg,.png">
            <img style="width: 200px;height: 150px;" v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon" style="line-height:150px;text-align:center;margin-left:50px">
              <span style="font-size: 16px;">点击选择文件</span>
            </i>
          </el-upload>
          <p style="margin-top:10px;line-height:26px;width: 360px;margin-left:60px">图片大小需控制在500K以内 文件格式请用.jpg .png .jpeg 图片尺寸建议：300px*450px</p>
        </div>
        <div style="height: 110px;">
          <h2 style="display: inline-block;font-size: 18px;float: left;">标题</h2>
          <el-input style="width: 360px;margin-left:18px" v-model="materialName" placeholder="请输入标题" maxlength="10" show-word-limit></el-input>
          <el-button type="primary" style="margin-top:20px;margin-left:200px;" @click="savefun()" :loading="savaloading">保存</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 移动分组名称 -->
    <el-dialog title="移动分组" :visible.sync="dialogrenamesy" width="450px">
      <ul class="allMaterialGroups">
        <li v-for="(item,i) in allMaterialGroups" :key="i">
          <span style="float: left;">{{item.groupName}}</span>
          <span style="float:right;cursor:pointer;margin-right:10px;font-size:18px;line-height:38px;" @click="Movetofun(item.keyNo)">移动</span>
          <span style="float:right;cursor:pointer;font-size:18px;line-height:38px;" class="el-icon-delete" @click="dels(item.keyNo)"></span>
        </li>
      </ul>
    </el-dialog>
    <el-dialog title="图片裁剪" :visible.sync="Croppdialog" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeCroppdialog" width="640px">
      <PictureCropper ref="picture" :initialImg="imageUrl" :cropperHeight="cropperHeight" :cropperWidth="cropperWidth" :autoCropWidth="autoCropWidth" :autoCropHeight="autoCropHeight" @picturePreview="picturePreview" />

      <span slot="footer" class="dialog-footer">
        <el-button @click="Croppdialog=false;">取 消</el-button>
        <el-button type="primary" @click="closeCroppdialog(2)">确 定</el-button>
      </span> 
    </el-dialog>
  </div>
</template>
<script>
import PictureCropper from '@/components/pictureCropper.vue'
export default {
  components: {PictureCropper},
  data() {
    return {
      // 裁剪
      Croppdialog:false,
      dialogrenamesy:false,
      ypdz:'',//音频地址
      fmdz:'',//封面地址
      show_file:true,//
      materialName:'',
      imageUrl:'',
      Counts:0,
      Counts2:0,
      name:'',//搜素名称
      pageIndex:1,//
      pageSize:'10',//
      input3:'',//
      zzindex: '',
      groupName: '',//新加分组组名
      currentPage3: 1,
      dialogrename:false,//图片重命名
      dialogrename2:false,//分组重命名
      dialogrename3:false,//上传
      allMaterialGroups:[],//分组列表数据
      editkeyNo:'',//修改选中
      fzdataL: '',//修改分组的名称
      keyNo: '',
      datalist: '',
      selectedItems: [],
      selesdata: [],
      tpkey: '',
      Movetofundata: '',
      updataloading:false,
      savaloading:false,
    }
  },
  mounted() {
    this.materialGroup();


    // this.$Http_Post('management/getContentDetails', {MaterialKey:324}).then((resw) => {
    //       if (resw.Code == 200 || resw.Code == 0) {
    //       }
    //     })



  },
  methods: {
    Movetofun(id){
      if(this.Movetofundata == '多'){
        this.$Http_Post('management/mobileGroup', {materials:this.selesdata,keyNo:id}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.dialogrenamesy = false;
            window.location.reload();
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      }else{
        this.$Http_Post('management/mobileGroup', {materials:[this.Movetofundata],keyNo:id}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.dialogrenamesy = false;
            window.location.reload();
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      }
    },
    Movefun(key){
      this.Movetofundata = key;
      this.dialogrenamesy = true;
    },
    savefun(){
      if(this.ypdz && this.fmdz){
        if(this.materialName){
          this.savaloading=true;
          this.$Http_Post('management/uploadMaterial', {
            materialName:this.materialName,//素材名称
            materialPath:this.ypdz,//素材地址
            materialCover:this.fmdz,//素材封面
            keyNo:this.keyNo,//组合ID
            itemKey:'',
            materialType:'2'
          }).then((resw) => {
            this.savaloading=false;
            if (resw.Code == 200 || resw.Code == 0) {
              this.ypdz = '';//音频地址
              this.fmdz = '';//封面地址
              this.materialName = '';
              this.imageUrl = '';
              this.show_file = false;
              this.dialogrename3 = false;
              this.Global.request_successful(resw.Message);
              window.location.reload();
            }else{
       
            }
          })
        }else{
          this.Global.request_failure('请输入标题！');
        }
      }else{
        this.Global.request_failure('请上传音频和封面！');
      }
    },

    handleChange2(file, fileList) {
      this.show_file = true
      this.updataloading=true;

      // 自动将文件名（不含扩展名）赋值到标题
      const fileName = file.name;
        const fileNameWithoutExt = fileName.replace(/\.[^/.]+$/, ""); // 移除文件扩展名
        this.materialName = fileNameWithoutExt;  


      var formData = new FormData();
      formData.append('images', file.raw);
      this.$Http_Post('AppUser/UpdatePortraitAndCertificate', formData).then((resw) => {
        this.updataloading=false;
        if (resw.Code == 200 || resw.Code == 0) {
          this.ypdz = resw.Data;
          return false;
        }
      })
    },
    // 确认裁剪并关闭弹窗
    async closeCroppdialog(e){
      this.Croppdialog=false;
      if(e==2){//确认裁剪并关闭
        this.imageUrl=await this.$refs.picture.getBase64();
        this.imageFile=await this.$refs.picture.getfile(this.imageUrl,Math.floor(new Date().getTime())+'.png');
      }
    },
    toggleSelect(value,index){
      if (!this.isSelected(index)) {
        this.selectedItems.push(index);
        this.selesdata.push(value);
      } else {
        const indexToRemove = this.selectedItems.indexOf(index);
        this.selectedItems.splice(indexToRemove, 1);
        this.selesdata.splice(indexToRemove, 1);
      }
    },

    isSelected(index) {
      return this.selectedItems.includes(index);
    },
    publish(materialKey){//发布

      this.$router.push({
        path: '/propagate/Audio_edit',
        query: { materialKey: materialKey},
      })
    },
    publish2(materialKey){//发布

      console.log(this.selesdata)
      if(this.selesdata.length == 1){
        this.$router.push({
          path: '/propagate/Audio_edit',
          query: { materialKey: this.selesdata[0]},
        })
      }else{
        this.Global.request_failure('只能选择一个图片发布！');
      }
    },
    delfun(val){//删除
      var MaterialKeys = [val];
      this.$Http_Post('management/materialDelS', {MaterialKeys:MaterialKeys}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loading();
          this.selectedItems = [];
          this.selesdata = [];
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    rename(val){//重命名
      this.tpkey = val
      this.dialogrename = true;
    },
    renamefun(){//重命名确定

      this.$Http_Post('management/updateMaterial', {materialName:this.input3,materialKeyNo:this.tpkey}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
          
        } else {
          this.Global.request_failure(res.Message);
        }
      })

      // input3
      this.dialogrename = false;
    },

    zzfun(i,item){
      this.zzindex = i;
      this.keyNo = item.keyNo;
      this.pageIndex = 1;
      this.loading();
    },
    handleSizeChange(val) {
      this.pageIndex = val;
      this.loading();
    },
    addGroup(){//新增分组1图片2音频3视频
      if(this.groupName){
        this.$Http_Post('management/addGroup', {type:2,groupName:this.groupName}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.materialGroup();
            this.groupName = '';
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      }else{
        this.Global.request_failure('请输入分组名！');
      }
    },
    materialGroup(){//分组列表
      this.$Http_Post('/management/materialGroup', {type:2,pageIndex:1,pageSize:100}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Counts = res.Counts;
          this.allMaterialGroups = res.Data.allMaterialGroups;
          this.keyNo = res.Data.allMaterialGroups[0].keyNo;
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    dels(id){//删除分组
      this.$Http_Post('/management/delGroup', {keyNo:id}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.materialGroup();
          this.Global.request_successful(res.Message);
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    edit(id){
      this.editkeyNo = id;
      this.dialogrename2 = true;
    },
    editfun(){
      this.$Http_Post('management/updateGroup', {keyNo:this.editkeyNo,groupName:this.fzdataL}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.materialGroup();
          this.dialogrename2 = false;
          this.fzdataL = '';
          this.Global.request_successful(res.Message);
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    loading(){
      this.$Http_Post('management/getMaterialByGroup', {pageIndex:this.pageIndex,pageSize:this.pageSize,name:this.name,keyNo:this.keyNo}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Counts2 = res.Counts;
          this.datalist = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    deselect(){//取消选择
      this.selectedItems = [];
      this.selesdata = [];
    },
    pldel(){//批量删除
      if(this.selesdata.length > 0) {
        this.$Http_Post('management/materialDelS', {MaterialKeys:this.selesdata}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loading();
            this.selectedItems = [];
            this.selesdata = [];
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      }else{
        this.Global.request_failure('请选择删除选项!');
      }
    },

    handleChange3(file, fileList) {
      this.updataloading=true;
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw);        
        var formData = new FormData();
        this.Croppdialog = true;  
        formData.append('images', file.raw);
        this.$Http_Post('AppUser/UpdatePortraitAndCertificate', formData).then((resw) => {
          this.updataloading=false;
          if (resw.Code == 200 || resw.Code == 0) {
            this.fmdz = resw.Data
          }
        })
      } else {
        this.updataloading=false;
        this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
      }
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      this.updataloading=true;
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isLt2M) {
        this.updataloading=false;
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },


  },
}
</script>
<style>
.cropper-content-box{height:500px !important;width:600px !important;}
.Material_management{height: 100%;background-color: #fff;min-width:1600px;min-height:1100px;}
.Material_management .el-tabs{min-width: 1400px;}
.Material_management .el-tabs__nav{margin-left: 15px;}
.tp{width: 100%;height: 100%;padding:0px 15px 15px 15px;}
.Material_management .input-with-select{width: 300px;margin-left: 200px;}
.Material_management .tp_ul1{width: calc(100% - 320px);display: inline-block;}
.Material_management .tp_ul1 li{float: left;width: 200px;text-align: center;line-height: 34px;text-align: center;cursor: pointer;}
.Material_management .Select{color: rgba(0, 136, 255, 1);box-shadow:0 0 1px 1px rgba(0, 136, 255, 1);border-radius: 20px;}
.Material_management .nav_ul{height: 880px;}
.Material_management .nav_ul li{width: 300px;height: 230px;float: left;margin-left: 15px;margin-top: 15px;position: relative;}
.Material_management .nav_ul li img{width: 300px;height: 168.75px;}
.Material_management .nav_ul li p{width: 100%;text-align: center;font-weight: 700;margin-top: 15px;border-radius: 5px;}
.select{border: 1px solid #123456;}
.Material_management .nav_ul li:hover .cz{display: block;}
.Material_management .nav_ul .sibling{height: 104px;width: 72px;background: #fff;position: absolute;top:45px;right: 10px;display: none;}
.Material_management .nav_ul .cz{display: none;}
.Material_management .nav_ul .cz:hover + .sibling {display: block;}
.Material_management .nav_ul .sibling:hover{display: block;}
.Material_management .sibling ul{width: 100%;height: 100%;}
.Material_management .sibling ul li{width: 100%;text-align: center;height: 26px;margin: 0px;font-size: 12px;cursor: pointer;line-height: 26px;}
.Material_management .sibling ul li:hover{background-color: rgba(242, 242, 242, 1)}
.allMaterialGroups{height: 470px;overflow: auto;}
.allMaterialGroups li{height: 40px;line-height: 40px;border-bottom: 1px solid rgba(201, 201, 201, 1);text-indent: 15px;}
.allMaterialGroups li:hover{background-color: #cecece}
</style>
